import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const PathologicalAnatomyIcon = React.memo(({ width = 81, height = 80, viewBox = '0 0 81 80' }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={remCss(width)}
    height={remCss(height)}
    viewBox={viewBox}
  >
    <path
      fill={variables['colors-mc-primary']}
      fillOpacity='0.1'
      stroke={variables['colors-mc-primary']}
      d='M79.5 40C79.5 61.8153 61.8153 79.5 40 79.5C18.1848 79.5 0.5 61.8153 0.5 40C0.5 18.1848 18.1848 0.5 40 0.5C61.8153 0.5 79.5 18.1848 79.5 40Z'
    />
    <g clipPath='url(#clip0_414_13949)'>
      <path
        d='M42.1066 21.7991C43.9779 21.7991 45.4949 20.2821 45.4949 18.4108C45.4949 16.5395 43.9779 15.0225 42.1066 15.0225C40.2353 15.0225 38.7183 16.5395 38.7183 18.4108C38.7183 20.2821 40.2353 21.7991 42.1066 21.7991Z'
        fill='#E64C3C'
      />
      <path
        d='M46.8502 23.5696C46.4182 23.5696 46.6215 23.6459 42.3946 19.8933C42.0675 19.5792 42.0459 19.0632 42.3454 18.7228C42.645 18.3824 43.1596 18.3382 43.5127 18.6227L47.4093 22.0872C47.6733 22.3201 47.7658 22.692 47.6416 23.0215C47.5173 23.3509 47.2023 23.5691 46.8502 23.5696Z'
        fill='#E57E25'
      />
      <path
        d='M61.1655 21.7989C62.8028 21.7989 64.1302 20.4715 64.1302 18.8342C64.1302 17.1968 62.8028 15.8694 61.1655 15.8694C59.5281 15.8694 58.2007 17.1968 58.2007 18.8342C58.2007 20.4715 59.5281 21.7989 61.1655 21.7989Z'
        fill='#E64C3C'
      />
      <path
        d='M56.3203 23.8915C55.9657 23.8916 55.6485 23.6706 55.5256 23.3379C55.4028 23.0052 55.5002 22.6312 55.7697 22.4007L60.1915 18.6142C60.547 18.3102 61.0818 18.3519 61.3858 18.7074C61.6899 19.063 61.6482 19.5977 61.2927 19.9018C56.5067 24.0355 56.7523 23.8915 56.3203 23.8915Z'
        fill='#E57E25'
      />
      <path
        d='M41.0139 37.4361L38.6166 39.8249C38.4576 39.9853 38.2411 40.0755 38.0152 40.0755C37.7893 40.0755 37.5728 39.9853 37.4138 39.8249L35.025 37.4361L33.8222 38.6305C33.4918 38.9589 32.9582 38.9589 32.6278 38.6305L31.4249 37.4361C31.2646 37.2771 31.1744 37.0606 31.1744 36.8347C31.1744 36.6088 31.2646 36.3923 31.4249 36.2333L29.4004 34.2088C28.5609 35.1353 27.2793 35.5242 26.0664 35.2205C24.8535 34.9167 23.9065 33.9697 23.6027 32.7568C23.299 31.5439 23.6879 30.2623 24.6145 29.4228L18.8459 23.6542C18.5174 23.3238 18.5174 22.7902 18.8459 22.4598L19.4473 21.8584L16.4571 18.8682C16.2967 18.7092 16.2065 18.4927 16.2065 18.2668C16.2065 18.0409 16.2967 17.8244 16.4571 17.6654L18.8459 15.2681C19.006 15.0971 19.2299 15 19.4642 15C19.6986 15 19.9224 15.0971 20.0826 15.2681L23.0389 18.2668L23.6403 17.6654C23.7994 17.505 24.0159 17.4148 24.2417 17.4148C24.4676 17.4148 24.6841 17.505 24.8432 17.6654L37.4138 30.2699C37.5728 30.1095 37.7893 30.0193 38.0152 30.0193C38.2411 30.0193 38.4576 30.1095 38.6166 30.2699L39.811 31.4642C39.9714 31.6233 40.0616 31.8398 40.0616 32.0657C40.0616 32.2915 39.9714 32.508 39.811 32.6671L38.6166 33.8615L41.0139 36.1994C41.1849 36.3596 41.282 36.5834 41.282 36.8178C41.282 37.0521 41.1849 37.276 41.0139 37.4361Z'
        fill='#7F8C8D'
      />
      <path
        d='M21.7769 57.3762H43.8009C46.14 57.3762 48.0363 59.2725 48.0363 61.6116V64.1528H17.5415V61.6116C17.5415 59.2725 19.4377 57.3762 21.7769 57.3762Z'
        fill='#3B97D3'
      />
      <path
        d='M41.0307 48.9056C38.7518 52.1106 34.8286 53.7135 30.9575 53.0213C27.0863 52.3291 23.9616 49.4661 22.9345 45.67C21.9074 41.8739 23.1621 37.8259 26.1561 35.2762L23.4708 31.9641C18.9787 35.7916 17.2766 41.9726 19.1761 47.5601C21.0756 53.1477 26.1921 57.0107 32.0863 57.3073C37.9804 57.604 43.459 54.2742 45.9099 48.9056H41.0307Z'
        fill='#285680'
      />
      <path
        d='M30.0099 33.2007H30.0015'
        stroke='black'
        strokeWidth='17.3559'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M30.2475 31.9638C30.246 33.5227 29.181 34.8795 27.6671 35.2512C26.1531 35.6229 24.5809 34.9136 23.8576 33.5327C23.1343 32.1517 23.4467 30.4554 24.6144 29.4226C25.6132 28.5392 27.0371 28.3238 28.2525 28.8721C29.4679 29.4204 30.2487 30.6305 30.2475 31.9638Z'
        fill='#35495E'
      />
      <path
        d='M37.4138 30.2699L31.425 36.1994L29.4005 34.2088C30.6135 32.8701 30.5629 30.8152 29.2855 29.5378C28.0081 28.2604 25.9532 28.2098 24.6145 29.4228L18.8459 23.6542C18.5175 23.3238 18.5175 22.7902 18.8459 22.4598L23.6404 17.6654C23.7994 17.505 24.0159 17.4148 24.2418 17.4148C24.4677 17.4148 24.6842 17.505 24.8432 17.6654L37.4138 30.2699Z'
        fill='#3B97D3'
      />
      <path
        d='M39.8109 32.6414C36.4226 36.0297 35.9483 36.5126 33.8221 38.6303C33.4917 38.9587 32.9581 38.9587 32.6277 38.6303L31.4249 37.4359C31.2645 37.2768 31.1743 37.0603 31.1743 36.8344C31.1743 36.6086 31.2645 36.3921 31.4249 36.233L37.4137 30.2696C37.5728 30.1092 37.7893 30.019 38.0151 30.019C38.241 30.019 38.4575 30.1092 38.6166 30.2696L39.8109 31.464C40.1283 31.7923 40.1283 32.3131 39.8109 32.6414Z'
        fill='#2980BA'
      />
      <path
        d='M49.7301 64.9998H15.8471C15.3792 64.9998 15 64.6206 15 64.1527C15 63.6849 15.3792 63.3057 15.8471 63.3057H49.7301C50.198 63.3057 50.5772 63.6849 50.5772 64.1527C50.5772 64.6206 50.198 64.9998 49.7301 64.9998Z'
        fill='#35495E'
      />
      <path
        d='M53.9064 34.0306C50.7315 35.2779 47.1244 33.9708 45.4854 30.9792C43.8465 27.9877 44.6866 24.2442 47.4468 22.2399C50.2069 20.2356 54.0267 20.5953 56.3641 23.0797C58.7015 25.564 58.828 29.3986 56.6594 32.0315L53.9064 34.0306Z'
        fill='#F29C1F'
      />
      <path
        d='M55.6596 36.4621L53.2624 33.15C52.8992 32.6582 52.826 32.0101 53.0703 31.4497C53.3146 30.8893 53.8394 30.5018 54.4468 30.4332C55.0543 30.3646 55.6522 30.6253 56.0154 31.117L58.5566 34.5731L55.6596 36.4621Z'
        fill='#E57E25'
      />
      <path
        d='M48.036 28.5755C47.5682 28.5755 47.189 28.1962 47.189 27.7284C47.189 24.6112 50.1791 23.5777 50.3062 23.5354C50.7506 23.3857 51.2323 23.6246 51.382 24.069C51.5317 24.5135 51.2928 24.9951 50.8483 25.1448C49.7298 25.5276 48.9535 26.5483 48.8831 27.7284C48.8831 28.1962 48.5039 28.5755 48.036 28.5755Z'
        fill='#FAC176'
      />
      <path
        d='M48.8831 48.9054H39.5652C38.6296 48.9054 37.8711 48.1469 37.8711 47.2112C37.8711 46.2756 38.6296 45.5171 39.5652 45.5171H48.8831C49.8187 45.5171 50.5772 46.2756 50.5772 47.2112C50.5772 48.1469 49.8187 48.9054 48.8831 48.9054Z'
        fill='#2980BA'
      />
      <path
        d='M44.2241 45.5171C45.3937 45.5171 46.3418 44.569 46.3418 43.3994C46.3418 42.2299 45.3937 41.2817 44.2241 41.2817C43.0546 41.2817 42.1064 42.2299 42.1064 43.3994C42.1064 44.569 43.0546 45.5171 44.2241 45.5171Z'
        fill='#F29C1F'
      />
      <path
        d='M59.4714 43.823C62.0445 43.823 64.1303 41.7371 64.1303 39.164C64.1303 36.591 62.0445 34.5051 59.4714 34.5051C56.8984 34.5051 54.8125 36.591 54.8125 39.164C54.8125 41.7371 56.8984 43.823 59.4714 43.823Z'
        fill='#E64C3C'
      />
    </g>
    <defs>
      <clipPath id='clip0_414_13949'>
        <rect width='50' height='50' fill='white' transform='translate(15 15)' />
      </clipPath>
    </defs>
  </svg>
));
PathologicalAnatomyIcon.displayName = 'PathologicalAnatomyIcon';

export default PathologicalAnatomyIcon;
